module.exports = __webpack_public_path__ + "static/media/logo-navbar-old.ec590b5f.png";